import { ReactNode } from 'react';
import StockBalancesFiltersContainer from '../../containers/StockBalancesFiltersContainer/StockBalancesFiltersContainer';
import { useStockBalancesFiltersContext } from '../StockBalancesFiltersContext/StockBalancesFiltersContext';

type TProps = {
  children?: ReactNode;
  className?: string;
};

const StockBalancesTableHeaderWrapper = ({ children, className }: TProps) => {
  const { regionOptions, categoryOptions, filterRevision } = useStockBalancesFiltersContext();

  return (
    <StockBalancesFiltersContainer
      className={className}
      regionOptions={regionOptions}
      categoryOptions={categoryOptions}
      filterRevision={filterRevision}
    >
      {children}
    </StockBalancesFiltersContainer>
  );
};

export default StockBalancesTableHeaderWrapper;
